"use client";
import React from "react";
import AdBanner from "../AdBanner";
import { X } from "lucide-react";
import {
  Card,
  CardHeader,
  CardBody,
  Modal,
  ModalContent,
  Button,
} from "@heroui/react";

export const DefAd = () => {
  const [open, setOpen] = React.useState(true);

  return (
    open && (
      <Card
        radius="sm"
        className="bg-default flex flex-col gap-2 items-end fixed bottom-6 right-6 z-50">
        <CardHeader className="pb-0 justify-between items-center">
          <span>Reklama</span>
          <Button
            isIconOnly
            radius="full"
            variant="ghost"
            size="sm"
            onPress={() => setOpen(false)}>
            <X />
          </Button>
        </CardHeader>
        <CardBody>
          <div className="w-80">
            <AdBanner
              data-ad-slot="5759306487"
              data-ad-format="auto"
              data-full-width-responsive="true"
            />
          </div>
        </CardBody>
      </Card>
    )
  );
};
